<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <!--  -->
    <div class="topV">
      <div class="topbg"></div>
      <div class="top_box">
        <div class="currency_box form_box">
          <div class="video_box">
            <video controls
                   class="video"
                   :loop="true"
                   muted
                   :autoplay="true"
                   :src="videoUrl"></video>
          </div>
          <div class="form_content">
            <h2 style="margin:5px 0;color:#DE1F26;font-weight: 600;font-size: 24px;">我要解决问题</h2>
            <el-form ref="form"
                     :model="form"
                     :rules="rules">
              <el-form-item prop="problemsList">
                <el-checkbox-group v-model="form.problemsList"
                                   :min="1">
                  <el-checkbox v-for="city in cities"
                               :label="city.paramName"
                               :key="city.paramValue">{{city.paramName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="userName">
                <el-input placeholder="您的称呼"
                          maxlength="10"
                          @input="form.userName = form.userName.replace(/\s+/g,'')"
                          v-model="form.userName"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input placeholder="您的手机号"
                          maxlength="11"
                          v-model="form.phone"></el-input>
              </el-form-item>
              <!-- <el-form-item>
              <el-input placeholder="验证码"
                        v-model="form.name"></el-input>
            </el-form-item> -->
              <el-form-item>
                <el-button style="width:100%;background-color: #DE1F26;height:50px;"
                           type="primary"
                           @click="submitForm">获取诊断服务</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 咨询顾问 -->
    <div class="channel_box"
         :style="{'backgroundImage':'url(' + $imgUrl+ 'home/bj/bj1.jpg)','backgroundSize':'100% 100%' ,'backgroundRepeat': 'no-repeat'}">
      <div class="currency_box">
        <curTitle color="#fff"
                  :data="{title:'咨询顾问',content:'个性化定制提升方案，分阶段入驻企业落地'}"></curTitle>
      </div>
      <div class="currency_box"
           style="margin-top:40px">
        <adviser></adviser>
      </div>
    </div>
    <!-- 课程 -->
    <!-- <div class="curriculum_box">
      <curriculum-item></curriculum-item>
    </div> -->
    <!-- 服务内容  service-->
    <div class="online_box">
      <div class="currency_box"
           style="margin-bottom:20px">
        <curTitle color="#000"
                  :data="{title:'咨询顾问 | 服务内容',content:'战略定位，总部搭建，业绩提升，管理提效，财税管控'}"></curTitle>
      </div>
      <div class="currency_box">
        <service></service>
      </div>
    </div>
    <!-- 企业问题 -->
    <div class="problem_box"
         style="padding-top:40px">
      <div class="currency_box"
           style="margin-bottom:37px">
        <curTitle color="#fff"
                  :data="{title:'企业问题 系统解决',content:'四大体系 | 十大模块，结合企业实际个性化定制提升方案'}"></curTitle>
      </div>
      <div class="currency_box"
           v-for="(item,index) in contentList"
           :key="index">
        <el-image v-if="item.resourceType == 1"
                  style="width:100%;cursor: pointer;"
                  @click="$Public.link(item)"
                  :src="item.resourceUrl"></el-image>
        <video v-if="item.resourceType == 2"
               class="video"
               :controls="false"
               :autoplay="true"
               :src="item.resourceUrl"></video>
      </div>
    </div>
  </div>
</template>

<script>
const cityOptions = ['上海', '北京', '广州', '深圳', '杭州', '武汉'];
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue'
import adviser from './components/adviser.vue'
import service from './components/service.vue'
import curTitle from '@/components/home/cur_title.vue'
import { formAddApply, dictTypeList, resourceList } from '@/api/api.js'
export default {
  components: { curriculumItem, curTitle, adviser, service },
  data () {
    const validateMobile = (rule, value, callback) => {
      let regPhone = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if (value === '') {
        callback(new Error('请填写您的手机号'));
      } else if (!regPhone.test(value)) {
        callback(new Error('请输入正确的手机号格式!'));
      } else {
        callback();
      }
    };
    return {
      label: 'ow_consultant_label_list',
      cities: [],
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      videoUrl: '',
      form: {
        problems: '',
        problemsList: [],
        fromType: '2',
        enterpriseName: '',
        employeeNum: '',
        userName: '',
        phone: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入您的称呼', trigger: 'blur' },
        ],
        phone: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        problemsList: [
          { type: 'array', required: true, message: '请选择标签', trigger: 'change' }
        ]
      },
      contentList: [],
      data: {
        showIndex: 4,
        pageNumber: 1,
        pageSize: 100,
      }
    }
  },
  created () {
    this.getdictTypeList()
    this.getresourceList(4)
    this.getresourceList(11)
  },
  methods: {
    async getresourceList (type) {  //获取资源
      this.data.showIndex = type
      const res = await resourceList(this.data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      if (type == 4) {
        this.videoUrl = res.data[0].resourceUrl
      } else if (type == 11) {
        this.contentList = res.data;
      }

    },
    async getdictTypeList () {  //获取讲师分类
      const res = await dictTypeList('ow_consultant_label_list')
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      this.cities = res.data;
      console.log(this.cities)
      if (this.cities && this.cities.length != 0) {
        this.form.problemsList = [this.cities[0].paramName]
      }
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.getFormAddApply()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toStatus () {
      this.getFormAddApply()
      // this.$router.push('/Status')
    },
    getFormAddApply () {
      if (this.form.problemsList.length != 0) {
        this.form.problems = this.form.problemsList.join()
      }
      formAddApply(this.form).then(res => {
        if (res && res.code == 200) {
          this.$router.push('/Status?type=18')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background-color: #f5f5f5;
  .problem_box {
    min-width: 1200px;
    background-color: #282c34;
    padding: 60px 0 130px 0;
    box-sizing: border-box;
  }
  .online_box {
    background-color: #f5f5f5;
    min-width: 1200px;
    padding: 50px 0;
    box-sizing: border-box;
  }
  .curriculum_box {
    min-width: 1200px;
    background-color: #f5f5f5;
    margin-top: 60px;
  }
  .channel_box {
    min-width: 1200px;
    height: 652px;
    padding-top: 50px;
    background: rgba(0, 0, 0, 0.5);
  }
  .topV {
    position: relative;
    min-width: 1200px;
    height: 463px;
    .topbg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 79px;
      background: linear-gradient(0deg, #f5f5f5, #ffedee);
    }
    .top_box {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      .form_box {
        padding: 30px 0;
        box-sizing: border-box;
        height: 463px;
        // background-color: #fff;
        .video_box {
          flex: 1;
          height: 100%;
          margin-right: 20px;
          .video {
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
        .form_content {
          text-align: left;
          width: 480px;
          background-color: #ffffff;
          height: 100%;
          padding: 15px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
